import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage, injectIntl } from "react-intl";
import { i18nConfig } from "../../i18nConfig";
/**
 * Renders the 'Show more' button.
 */
export const ShowMoreOptions = injectIntl(({ intl, onShowMore }) => {
    const showMoreIconTitle = intl.formatMessage({
        id: "actions.showMoreOptions",
        defaultMessage: i18nConfig.messages["en"]["actions.showMoreOptions"],
    });
    return (_jsxs("button", { type: "button", className: "show-more-options", onClick: () => onShowMore(), "aria-label": showMoreIconTitle, "data-testid": "showMoreOptionsButton", children: [_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", children: _jsx("path", { d: "M9 6.5H6.5V9C6.5 9.275 6.275 9.5 6 9.5C5.725 9.5 5.5 9.275 5.5 9V6.5H3C2.725 6.5 2.5 6.275 2.5 6C2.5 5.725 2.725 5.5 3 5.5H5.5V3C5.5 2.725 5.725 2.5 6 2.5C6.275 2.5 6.5 2.725 6.5 3V5.5H9C9.275 5.5 9.5 5.725 9.5 6C9.5 6.275 9.275 6.5 9 6.5Z", fill: "#171C1E" }) }), _jsx(FormattedMessage, { id: "actions.showMoreOptions", defaultMessage: i18nConfig.messages["en"]["actions.showMoreOptions"] })] }));
});
